import React from 'react';
import './style.css';

function Button({ variant = 'primary', fullWidth = false, className = '', startIcon, endIcon, loading = false, disabled, children, ...rest }) {
  const classes = [
    'btn',
    variant === 'primary' && 'btn-primary',
    variant === 'secondary' && 'btn-secondary',
    variant === 'ghost' && 'btn-ghost',
    variant === 'outline' && 'btn-outline',
    fullWidth && 'btn-full-width',
    loading && 'btn-loading',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button className={classes} disabled={disabled || loading} {...rest}>
      {loading && <span className="btn-spinner" />}
      {!loading && startIcon && <span className="btn-start-icon">{startIcon}</span>}
      {children}
      {!loading && endIcon && <span className="btn-end-icon">{endIcon}</span>}
    </button>
  );
}

export default Button;

